"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadExcel = exports.createRCM = exports.getVersions = void 0;
var Translation_1 = require("@cck/common/dist/data/Translation");
var Config_1 = require("@cck/common/dist/utils/Config");
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var firebase = __importStar(require("../firebase/fbase"));
var Admin = __importStar(require("../utils/Admin"));
var Excel_1 = require("../utils/Excel");
var ControlManager = __importStar(require("./ControlManager"));
var CycleManager = __importStar(require("./CycleManager"));
var ProcessManager = __importStar(require("./ProcessManager"));
var createRCMInner = function () { return __awaiter(void 0, void 0, void 0, function () {
    var rcmGetDocumentObjectFromCollection, rcmGetDocumentObjectFromCollectionList, targetCollectionList, backupDataObject, documentObjectFromAllCollection;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rcmGetDocumentObjectFromCollection = function (collectionName) { return __awaiter(void 0, void 0, void 0, function () {
                    var collectionRef, documentObjectList;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, firebase.dbService.collection(collectionName).get()];
                            case 1:
                                collectionRef = _a.sent();
                                documentObjectList = collectionRef.docs.map(function (doc) {
                                    var obj = {};
                                    obj[doc.id] = doc.data();
                                    return obj;
                                });
                                return [2 /*return*/, documentObjectList];
                        }
                    });
                }); };
                rcmGetDocumentObjectFromCollectionList = function (collectionList) { return __awaiter(void 0, void 0, void 0, function () {
                    var result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                result = collectionList.map(function (collection) { return __awaiter(void 0, void 0, void 0, function () {
                                    var documentObjectList, obj;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, rcmGetDocumentObjectFromCollection(collection)];
                                            case 1:
                                                documentObjectList = _a.sent();
                                                obj = {};
                                                obj[collection] = documentObjectList;
                                                return [2 /*return*/, obj];
                                        }
                                    });
                                }); });
                                return [4 /*yield*/, Promise.all(result)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                }); };
                targetCollectionList = [
                    'CYCLE',
                    'PROCESS',
                    'RISK',
                    'CONTROL',
                    'STAFF',
                    'DEPARTMENT',
                    'NOTICE'
                ];
                backupDataObject = {};
                return [4 /*yield*/, rcmGetDocumentObjectFromCollectionList(targetCollectionList)];
            case 1:
                documentObjectFromAllCollection = _a.sent();
                documentObjectFromAllCollection.forEach(function (collectionObj) {
                    var collectionName = Object.keys(collectionObj)[0];
                    backupDataObject[collectionName] = {};
                    var targetCollectionObjectList = collectionObj[collectionName];
                    targetCollectionObjectList.forEach(function (documentObject) {
                        var documentId = Object.keys(documentObject)[0];
                        var documentData = documentObject[documentId];
                        backupDataObject[collectionName][documentId] = documentData;
                    });
                });
                return [2 /*return*/, backupDataObject];
        }
    });
}); };
var insertRCM = function (rcmVersionId, rcmData) { return __awaiter(void 0, void 0, void 0, function () {
    var rcmInsertEachCollection, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rcmInsertEachCollection = function (inputRcmVersionId, collectionName, collectionData) { return __awaiter(void 0, void 0, void 0, function () {
                    var baseDocRef, result;
                    return __generator(this, function (_a) {
                        baseDocRef = firebase.dbService.collection('RCM').doc(inputRcmVersionId);
                        result = Object.keys(collectionData).map(function (documentId) { return __awaiter(void 0, void 0, void 0, function () {
                            var docRef;
                            return __generator(this, function (_a) {
                                docRef = baseDocRef.collection(collectionName).doc(documentId);
                                return [2 /*return*/, docRef.set(collectionData[documentId])];
                            });
                        }); });
                        return [2 /*return*/];
                    });
                }); };
                result = Object.keys(rcmData).map(function (collectionName) { return __awaiter(void 0, void 0, void 0, function () {
                    var eachCollectionResult;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, rcmInsertEachCollection(rcmVersionId, collectionName, rcmData[collectionName])];
                            case 1:
                                eachCollectionResult = _a.sent();
                                return [2 /*return*/, eachCollectionResult];
                        }
                    });
                }); });
                return [4 /*yield*/, Promise.all(result)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var getVersions = function () { return __awaiter(void 0, void 0, void 0, function () {
    var targetCollectionRef, targetCollectionData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                targetCollectionRef = firebase.dbService.collection('RCM');
                return [4 /*yield*/, targetCollectionRef.get()];
            case 1:
                targetCollectionData = _a.sent();
                return [2 /*return*/, targetCollectionData.docs.map(function (docData) { return docData.id; })];
        }
    });
}); };
exports.getVersions = getVersions;
var createNewVersionId = function () { return __awaiter(void 0, void 0, void 0, function () {
    var versionIdList, lastVersionId, versionIdSplit, versionIdDate, versionIdNumberString, versionIdNumberInt, todayDate, newVersionIdDate, newVersionIdNumberString, newVersionIdNumberInt, newVersionId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.getVersions)()];
            case 1:
                versionIdList = _a.sent();
                lastVersionId = lodash_1.default.last(versionIdList);
                versionIdSplit = lodash_1.default.split(lastVersionId, '-');
                versionIdDate = versionIdSplit[0];
                versionIdNumberString = versionIdSplit[1];
                versionIdNumberInt = Number(versionIdNumberString);
                todayDate = (0, moment_1.default)().format('YYYYMMDD');
                newVersionIdDate = '';
                newVersionIdNumberString = '';
                newVersionIdNumberInt = 0;
                if (todayDate !== versionIdDate) {
                    newVersionIdDate = todayDate;
                    newVersionIdNumberString = '01';
                }
                else {
                    newVersionIdDate = versionIdDate;
                    newVersionIdNumberInt = versionIdNumberInt + 1;
                    newVersionIdNumberString =
                        newVersionIdNumberInt < 10
                            ? '0' + String(newVersionIdNumberInt)
                            : String(newVersionIdNumberInt);
                }
                newVersionId = lodash_1.default.join([newVersionIdDate, newVersionIdNumberString], '-');
                return [2 /*return*/, newVersionId];
        }
    });
}); };
var createRCM = function () { return __awaiter(void 0, void 0, void 0, function () {
    var currentUserId, isAdmin, newVersionId, rcmData, currentTime;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                currentUserId = (_a = firebase.authService.currentUser) === null || _a === void 0 ? void 0 : _a.email;
                if (!currentUserId) {
                    return [2 /*return*/, Promise.reject(new Error('RCM 버전 생성 - 로그인한 유저를 찾을 수 없습니다.'))];
                }
                return [4 /*yield*/, Admin.checkLevel(currentUserId)];
            case 1:
                isAdmin = _b.sent();
                if (!isAdmin) {
                    return [2 /*return*/, Promise.reject(new Error('RCM 버전 생성 - 관리자 권한이 아닙니다.'))];
                }
                return [4 /*yield*/, createNewVersionId()];
            case 2:
                newVersionId = _b.sent();
                return [4 /*yield*/, createRCMInner()];
            case 3:
                rcmData = _b.sent();
                currentTime = (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss');
                return [4 /*yield*/, insertRCM(newVersionId, rcmData).then(function () {
                        firebase.dbService.collection('RCM').doc(newVersionId).set({
                            updateTime: currentTime,
                            updater: currentUserId
                        });
                    })];
            case 4:
                _b.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.createRCM = createRCM;
var getRCM = function (versionId) { return __awaiter(void 0, void 0, void 0, function () {
    var rcmGetDocumentObjectFromCollection, rcmGetDocumentObjectFromCollectionList, collectionList, rcmDataObject, documentObjectForBackup;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rcmGetDocumentObjectFromCollection = function (inputVersionId, collectionName) { return __awaiter(void 0, void 0, void 0, function () {
                    var collectionRef, documentObjectList;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, firebase.dbService
                                    .collection('RCM')
                                    .doc(inputVersionId)
                                    .collection(collectionName)
                                    .get()];
                            case 1:
                                collectionRef = _a.sent();
                                documentObjectList = collectionRef.docs.map(function (doc) {
                                    var obj = {};
                                    obj[doc.id] = doc.data();
                                    return obj;
                                });
                                return [2 /*return*/, documentObjectList];
                        }
                    });
                }); };
                rcmGetDocumentObjectFromCollectionList = function (inputVersionId, collectionList) { return __awaiter(void 0, void 0, void 0, function () {
                    var result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                result = collectionList.map(function (collection) { return __awaiter(void 0, void 0, void 0, function () {
                                    var documentObjectList, obj;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, rcmGetDocumentObjectFromCollection(inputVersionId, collection)];
                                            case 1:
                                                documentObjectList = _a.sent();
                                                obj = {};
                                                obj[collection] = documentObjectList;
                                                return [2 /*return*/, obj];
                                        }
                                    });
                                }); });
                                return [4 /*yield*/, Promise.all(result)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                }); };
                collectionList = ['CYCLE', 'PROCESS', 'RISK', 'CONTROL'];
                rcmDataObject = {};
                return [4 /*yield*/, rcmGetDocumentObjectFromCollectionList(versionId, collectionList)];
            case 1:
                documentObjectForBackup = _a.sent();
                documentObjectForBackup.forEach(function (collectionObj) {
                    var collectionName = Object.keys(collectionObj)[0];
                    rcmDataObject[collectionName] = {};
                    var targetCollectionObjectList = collectionObj[collectionName];
                    targetCollectionObjectList.forEach(function (documentObject) {
                        var documentId = Object.keys(documentObject)[0];
                        var documentData = documentObject[documentId];
                        rcmDataObject[collectionName][documentId] = documentData;
                    });
                });
                return [2 /*return*/, rcmDataObject];
        }
    });
}); };
var downloadExcel = function (versionId) { return __awaiter(void 0, void 0, void 0, function () {
    var cycleDataAll, processDataAll, controlDataAll, _a, CYCLE, PROCESS, RISK, CONTROL, processExcelResult, orderingMap, rcmExcelResult;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                cycleDataAll = [];
                processDataAll = [];
                controlDataAll = [];
                if (!(versionId === 'NOW')) return [3 /*break*/, 4];
                return [4 /*yield*/, CycleManager.getAll()];
            case 1:
                cycleDataAll = _b.sent();
                return [4 /*yield*/, ProcessManager.getAll()];
            case 2:
                processDataAll = _b.sent();
                return [4 /*yield*/, ControlManager.getAll()];
            case 3:
                controlDataAll = _b.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, getRCM(versionId)];
            case 5:
                _a = _b.sent(), CYCLE = _a.CYCLE, PROCESS = _a.PROCESS, RISK = _a.RISK, CONTROL = _a.CONTROL;
                cycleDataAll = Object.values(CYCLE);
                processDataAll = Object.values(PROCESS);
                controlDataAll = Object.values(CONTROL);
                _b.label = 6;
            case 6:
                processExcelResult = [];
                processDataAll.forEach(function (processData) {
                    var _a;
                    var cycleId = processData.cycleIds[0];
                    var cycleData = lodash_1.default.find(cycleDataAll, { id: cycleId });
                    if (cycleData) {
                        var result = (_a = {},
                            _a[(0, Translation_1.getKoName)('common', 'cycleNumber')] = cycleData.cycleNumber,
                            _a[(0, Translation_1.getKoName)('common', 'cycleName')] = cycleData.cycleName,
                            _a[(0, Translation_1.getKoName)('common', 'categoryNumber')] = cycleData.categoryNumber,
                            _a[(0, Translation_1.getKoName)('common', 'categoryName')] = cycleData.categoryName,
                            _a[(0, Translation_1.getKoName)('common', 'subCategoryNumber')] = cycleData.subCategoryNumber,
                            _a[(0, Translation_1.getKoName)('common', 'subCategoryName')] = cycleData.subCategoryName,
                            _a['프로세스 코드'] = processData.id,
                            _a['프로세스 이름'] = processData.name,
                            _a['프로세스 설명'] = processData.narrative,
                            _a);
                        processExcelResult.push(result);
                    }
                });
                orderingMap = (0, Config_1.getControlClass)().getKeysForExporting();
                rcmExcelResult = [];
                controlDataAll.forEach(function (controlData) {
                    // key 이름과 순서를 알맞게 수정해준다
                    var convertedResult = {};
                    for (var _i = 0, _a = Object.entries(orderingMap); _i < _a.length; _i++) {
                        var _b = _a[_i], key = _b[0], value = _b[1];
                        if (key && value) {
                            convertedResult[value] = lodash_1.default.get(controlData, key);
                        }
                    }
                    rcmExcelResult.push(convertedResult);
                });
                // 엑셀파일 만들기(자동으로 다운로드됨)
                return [4 /*yield*/, (0, Excel_1.createRcmExcel)('PROCESS.xlsx', versionId, processExcelResult)];
            case 7:
                // 엑셀파일 만들기(자동으로 다운로드됨)
                _b.sent();
                return [4 /*yield*/, (0, Excel_1.createRcmExcel)('RCM.xlsx', versionId, rcmExcelResult)];
            case 8:
                _b.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.downloadExcel = downloadExcel;
//# sourceMappingURL=RcmManager.js.map